export default __webpack_public_path__ + "static/media/alat.b3cfc848.png";